<template>
  <div>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">申し立て動画: {{ item.title }}</h3>
      </div>
      <div class="page-block__inner">
        <div
          class="my-release-list"
          style="min-height: 340px">
          <div
            v-if="!loading"
            class="youtube-detail-box">
            <!-- eslint-disable vue/no-v-html -->
            <div
              v-if="item.playerHtml"
              style="margin-right: 12px;"
              v-html="item.playerHtml">
            </div>
            <div
              v-else
              style="color: grey; width: 640px; height: 320px;padding: 20px 50px">
              申し立てを行った動画はアップロードしたユーザーによって非公開に設定されています。
            </div>
            <!-- eslint-enable vue/no-v-html -->
            <div>
              <div style="display: flex">
                <div
                  v-if="item.channel.thumbnailUrl">
                  <img
                    class="channel-icon"
                    :src="item.channel.thumbnailUrl"
                    :alt="item.channel.channelTitle" />
                </div>
                <div>
                  <a
                    class="link-title"
                    :href="`https://www.youtube.com/channel/${item.channelId}/`"
                    target="_blank">
                    {{ item.channelTitle }}
                    <img
                      src="/img/common/icon-link.svg"
                      width="14"
                      height="14"
                      style="margin-top: 5px" />
                  </a>
                  <div style="padding-left: 10px; font-size: 12px; color: grey">
                    チャンネル登録者数 {{ item.channel.subscriberCount | number }}人 /
                    {{ item.channel.videoCount }}本の動画
                  </div>
                </div>
                <div style="margin-left: auto;">
                  <a
                    v-tooltip="pcTooltipConfig('チャンネルIDをコピー')"
                    class="link-title"
                    href="javascript: void(0);"
                    @click.prevent="handleCopyToClipBoard()">
                    <svg
                      style="fill: currentColor;"
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24">
                      <path d="M24 4h-20v20h20v-20zm-24 17v-21h21v2h-19v19h-2z" />
                    </svg>
                  </a>
                </div>
              </div>
              <div style="margin: 8px auto auto 12px;">
                <div class="youtube-policy youtube-policy-header">
                  <div class="youtube-policy-label">
                  </div>
                  <div class="youtube-policy-value">
                    収益化
                  </div>
                  <div class="youtube-policy-value">
                    トラッキング
                  </div>
                  <div class="youtube-policy-value">
                    ブロック
                  </div>
                </div>
                <div class="youtube-policy">
                  <div class="youtube-policy-label">
                    現在のポリシー:
                  </div>
                  <div class="youtube-policy-value">
                    {{ item.policies.current.monetize }}
                  </div>
                  <div class="youtube-policy-value">
                    {{ item.policies.current.tracking }}
                  </div>
                  <div class="youtube-policy-value">
                    {{ item.policies.current.block }}
                  </div>
                </div>
                <div class="youtube-policy">
                  <div class="youtube-policy-label">
                    申し立てのポリシー:
                  </div>
                  <div class="youtube-policy-value">
                    {{ item.policies.request.monetize }}
                  </div>
                  <div class="youtube-policy-value">
                    {{ item.policies.request.tracking }}
                  </div>
                  <div class="youtube-policy-value">
                    {{ item.policies.request.block }}
                  </div>
                </div>
                <hr />
                <div style="display: flex">
                  <div class="youtube-detail-label">動画ID</div>
                  <div class="youtube-detail-value">
                    <a
                      class="link-title"
                      style="padding-left: 0;"
                      :href="`https://www.youtube.com/watch?v=${videoId}`"
                      target="_blank">
                      {{ videoId }}
                      <img
                        src="/img/common/icon-link.svg"
                        width="14"
                        height="14"
                        style="margin-top: 3px" />
                    </a>
                  </div>
                </div>
                <div style="display: flex">
                  <div class="youtube-detail-label">公開日</div>
                  <div class="youtube-detail-value">
                    {{ item.publishedAt | formatDate('YYYY/MM/DD HH:mm') }}
                  </div>
                </div>
                <div style="display: flex">
                  <div class="youtube-detail-label">説明</div>
                  <div class="youtube-detail-value description">{{ item.description }}</div>
                </div>
                <div style="display: flex">
                  <div class="youtube-detail-label">動画のタグ</div>
                  <div class="youtube-detail-value">
                    <span v-if="item.tag">{{ tag(item.tag) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="!loading"
      class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">
          動画に対する申し立て
        </h3>
      </div>

      <claim-request-table
        v-if="item.claimsForMe.length > 0"
        title="自分"
        :video="item"
        :items="item.claimsForMe" />

      <claim-request-table
        v-if="item.claimsForOther.length > 0"
        title="その他"
        :video="item"
        :items="item.claimsForOther" />

      <div class="page-block__inner">
        <a
          class="c-btn c-btn--back"
          href="#"
          @click.prevent="close">
          戻る
          <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment/moment'
import YouTubeClaimRequestTable from './ClaimRequestTable'
import Tooltip from '../../../../mixins/tooltip'

export default {
  name: 'YouTubeClaimsClaimDetail',
  components: {
    ClaimRequestTable: YouTubeClaimRequestTable,
  },
  mixins: [
    Tooltip,
  ],
  props: {
    videoId: {
      type: String,
      default: null,
    },
    isShown: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      item: {
        channel: {},
        policies: {
          current: {},
          request: {},
        },
        claimsForMe: [],
        claimsForOther: [],
      },
      loading: true,
    }
  },
  computed: {
    moment() {
      return moment
    },
  },
  watch: {
    videoId: {
      immediate: true,
      handler(id) {
        if (id) {
          this.fetchItem(id)
        }
      },
    },
  },
  mounted() {
  },
  methods: {
    async fetchItem(id) {
      this.loading = true
      try {
        const { data } = await window.axios.get(`/api/client/youtube/claims/detail/${id}`)
        this.loading = false
        this.item = data
      } catch (e) {
        this.loading = false
      }
    },
    close() {
      this.$emit('closed')
    },
    tag(tags) {
      return !tags ? '-' : tags.join(', ')
    },
    handleCopyToClipBoard() {
      const el = document.createElement('textarea')
      el.value = this.item.channelId
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
    },
  },
}
</script>

<style scoped>
.channel-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.description {
  word-break: break-all;
}
</style>
